import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { List, Package, Sliders } from 'lucide-react';
import CategoryManager from './components/CategoryManager';
import ItemManager from './components/ItemManager';

type TabType = 'categories' | 'items' | 'modifiers';

function MenuManagementPage() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<TabType>('items');

  const tabs = [
    { id: 'categories' as const, label: t('menu.categories'), icon: List },
    { id: 'items' as const, label: t('menu.items'), icon: Package },
    { id: 'modifiers' as const, label: t('menu.modifiers'), icon: Sliders },
  ];

  return (
    <div className="h-full flex flex-col bg-background">
      {/* Header */}
      <div className="border-b bg-card p-4">
        <h1 className="text-2xl font-bold">{t('menu.management')}</h1>
        <p className="text-sm text-muted-foreground mt-1">
          {t('menu.subtitle') || 'Manage menu categories, items, and modifiers'}
        </p>
      </div>

      {/* Tabs */}
      <div className="border-b bg-card px-4">
        <div className="flex gap-1">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-4 py-3 border-b-2 transition-colors ${
                  activeTab === tab.id
                    ? 'border-primary text-primary font-medium'
                    : 'border-transparent text-muted-foreground hover:text-foreground'
                }`}
              >
                <Icon className="h-4 w-4" />
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-6">
        <div className="max-w-6xl mx-auto">
          {activeTab === 'categories' && <CategoryManager />}
          {activeTab === 'items' && <ItemManager />}
          {activeTab === 'modifiers' && (
            <div className="rounded-lg border bg-card p-8 text-center text-muted-foreground">
              <Sliders className="h-16 w-16 mx-auto mb-4 opacity-20" />
              <p>{t('menu.modifierManagement') || 'Modifier management coming soon'}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MenuManagementPage;
